module.exports = __webpack_public_path__ + "static/media/bg.b868ec9e.png";